<template>
  <div class="goods-service-wrapper">
    <!-- Thanh bộ lọc + thêm mới -->
    <div class="search-table">
      <div class="filter-group">
        <el-input
          v-model="filters.itemCode"
          clearable
          style="width: 200px"
          placeholder="Theo mã hàng hóa"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        />
        <el-input
          v-model="filters.itemName"
          clearable
          style="width: 280px"
          placeholder="Theo tên hàng hóa, dịch vụ"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        />
      </div>
      <el-button type="success" icon="el-icon-plus" @click="openCreateDialog">
        Thêm hàng hóa, dịch vụ
      </el-button>
    </div>

    <!-- Bảng dữ liệu -->
    <el-table
      :data="rows"
      border
      v-loading="loading"
      :element-loading-text="$tableLoading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255,0)"
      :header-cell-style="tableHeaderColor"
      :max-height="$tableMaxHeight"
      :empty-text="textTable"
    >
      <el-table-column type="index" width="60" align="center" label="STT">
        <template v-slot:default="scope">
          {{ (filters.page - 1) * filters.limit + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="itemCode" label="Mã hàng hóa" min-width="130" align="center" />
      <el-table-column prop="itemName" label="Tên hàng hóa, dịch vụ" min-width="220" show-overflow-tooltip />
      <el-table-column label="Số lượng" min-width="100" align="center">
        <template v-slot:default="scope">
          {{ formatQuantity(scope.row.quantity) }}
        </template>
      </el-table-column>
      <el-table-column label="Đơn giá" min-width="140" align="right">
        <template v-slot:default="scope">
          {{ formatCurrency(scope.row.unitPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="unitName" label="Đơn vị tính" min-width="120" align="center" />
      <el-table-column label="Thuế GTGT" min-width="140" align="center">
        <template v-slot:default="scope">
          {{ formatTaxLabel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="itemNote" label="Ghi chú" min-width="220" show-overflow-tooltip />
      <el-table-column label="Tác vụ" width="170" fixed="right" align="center">
        <template v-slot:default="scope">
          <el-tooltip content="Chi tiết" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-view" circle @click="openDetailDialog(scope.row)" />
          </el-tooltip>
          <el-tooltip content="Chỉnh sửa" placement="top">
            <el-button type="warning" size="mini" icon="el-icon-edit" circle @click="openEditDialog(scope.row)" />
          </el-tooltip>
          <el-tooltip content="Xóa" placement="top">
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handleDelete(scope.row)" />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- Phân trang căn giữa -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.page"
        :page-sizes="listSizeLimit"
        :page-size="filters.limit"
        layout="prev, pager, sizes, next"
        :total="totalRows"
      />
    </div>

    <!-- Dialog tạo mới / chỉnh sửa / chi tiết -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="680px"
      append-to-body
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form ref="goodsForm" :model="form" :rules="currentRules" label-width="140px" label-position="left">

        <!-- Mã hàng hóa: ẩn khi tạo mới, hiển thị (readonly) khi sửa/chi tiết -->
        <el-form-item v-if="dialogMode !== 'create'" label="Mã hàng hóa">
          <el-input :value="form.itemCode" disabled />
        </el-form-item>

        <el-form-item label="Tên hàng hóa" prop="itemName">
          <el-input v-model="form.itemName" :disabled="isDetailMode" maxlength="255" />
        </el-form-item>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="Số lượng" prop="quantity">
              <el-input-number
                v-model="form.quantity"
                :disabled="isDetailMode"
                :precision="2"
                :step="0.01"
                :min="0.01"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Đơn vị tính" prop="unitName">
              <el-select
                v-model="form.unitName"
                :disabled="isDetailMode"
                filterable
                allow-create
                default-first-option
                placeholder="--Chọn đơn vị--"
                style="width: 100%"
                @change="onUnitNameChange"
              >
                <el-option
                  v-for="u in unitOptions"
                  :key="u"
                  :label="u"
                  :value="u"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="Đơn giá" prop="unitPrice">
              <el-input-number
                v-model="form.unitPrice"
                :disabled="isDetailMode"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Thuế GTGT" prop="taxPercentage">
              <el-select
                v-model="form.taxPercentage"
                :disabled="isDetailMode"
                style="width: 100%"
                placeholder="--Lựa chọn--"
                @change="handleTaxChange"
              >
                <el-option label="Khác" value="other" />
                <el-option label="Không chịu thuế" :value="-2" />
                <el-option label="Không kê khai" :value="-1" />
                <el-option label="0%" :value="0" />
                <el-option label="5%" :value="5" />
                <el-option label="8%" :value="8" />
                <el-option label="10%" :value="10" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12" v-if="String(form.taxPercentage) === 'other'">
          <el-col :span="12">
            <el-form-item label="Thuế khác (%)" prop="taxPercentageInput">
              <el-input-number
                v-model="form.taxPercentageInput"
                :disabled="isDetailMode"
                :controls="false"
                :min="0"
                style="width: 100%"
                placeholder="Nhập %"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Ghi chú" prop="itemNote">
          <el-input
            v-model="form.itemNote"
            :disabled="isDetailMode"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Đóng</el-button>
        <el-button
          v-if="!isDetailMode"
          type="primary"
          :loading="actionLoading"
          @click="handleSubmit"
        >
          {{ dialogMode === 'create' ? 'Tạo mới' : 'Cập nhật' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import NotifyMessage from '@/commonFuncion/NotifyMessage';
import sinvoiceConfigMixin from '@/global/mixin/sinvoiceConfig.mixin';
import sinvoiceGoodsMixin from '@/global/mixin/sinvoiceGoods.mixin';

const DEFAULT_UNIT_OPTIONS = ['Ngày','Tuần','Tháng','Năm','Buổi','Cái','Lần','Gói','Chiếc'];

export default {
  name: 'GoodsServiceManagement',
  mixins: [sinvoiceConfigMixin, sinvoiceGoodsMixin],
  data() {
    return {
      actionLoading: false,
      textTable: this.$tableEmpty || 'Không có dữ liệu',
      listSizeLimit: [10, 25, 50, 100],
      filters: {
        itemCode: '',
        itemName: '',
        page: 1,
        limit: 10
      },
      unitOptions: [...DEFAULT_UNIT_OPTIONS],
      dialogVisible: false,
      dialogMode: 'create', // 'create' | 'edit' | 'detail'
      form: {
        id: null,
        itemCode: '',
        itemName: '',
        quantity: 1,
        unitPrice: 0,
        unitName: '',
        taxPercentage: '',
        taxPercentageInput: null,
        itemNote: ''
      }
    };
  },
  computed: {
    rows() {
      return this.sinvoiceGoodsItems;
    },
    totalRows() {
      return this.sinvoiceGoodsTotal;
    },
    loading() {
      return this.sinvoiceGoodsLoading;
    },
    dialogTitle() {
      if (this.dialogMode === 'detail') return 'Chi tiết hàng hóa, dịch vụ';
      return this.dialogMode === 'create' ? 'Thêm hàng hóa, dịch vụ' : 'Cập nhật hàng hóa, dịch vụ';
    },
    isDetailMode() {
      return this.dialogMode === 'detail';
    },
    currentRules() {
      if (this.isDetailMode) return {};
      return {
        itemName: [{ required: true, message: 'Vui lòng nhập tên hàng hóa', trigger: 'blur' }],
        quantity: [
          {
            validator: (rule, value, callback) => {
              if (value === undefined || value === null || String(value).trim() === '') {
                return callback(new Error('Vui lòng nhập số lượng'));
              }
              const num = Number(value);
              if (!Number.isFinite(num) || num <= 0) {
                return callback(new Error('Số lượng phải lớn hơn 0'));
              }
              return callback();
            },
            trigger: 'change'
          }
        ],
        unitPrice: [{ required: true, message: 'Vui lòng nhập đơn giá', trigger: 'change' }],
        unitName: [{ required: true, message: 'Vui lòng chọn hoặc nhập đơn vị tính', trigger: 'change' }],
        taxPercentage: [
          {
            validator: (rule, value, callback) => {
              if (value === undefined || value === null || String(value).trim() === '') {
                return callback(new Error('Vui lòng chọn thuế GTGT'));
              }
              return callback();
            },
            trigger: 'change'
          }
        ],
        taxPercentageInput: [
          {
            validator: (rule, value, callback) => {
              if (String(this.form.taxPercentage) !== 'other') return callback();
              const custom = Number(value);
              if (!Number.isFinite(custom) || custom < 0) {
                return callback(new Error('Vui lòng nhập thuế GTGT hợp lệ'));
              }
              return callback();
            },
            trigger: 'change'
          }
        ],
      };
    }
  },
  created() {
    this.sanitizeUnitOptions();
    this.fetchData();
  },
  methods: {
    tableHeaderColor() {
      return 'background-color: #78a5e7;color: #fff;font-weight: 500;';
    },
    formatQuantity(value) {
      if (value === undefined || value === null || value === '') return '--';
      const num = Number(value);
      if (!Number.isFinite(num)) return '--';
      return Number(num.toFixed(2)).toString();
    },
    formatCurrency(value) {
      return `${new Intl.NumberFormat('vi-VN').format(Number(value) || 0)} VND`;
    },
    formatTaxLabel(row) {
      const tax = row && row.taxPercentage !== undefined ? row.taxPercentage : '';
      if (String(tax) === 'other') {
        if (row.taxPercentageInput !== null && row.taxPercentageInput !== undefined && String(row.taxPercentageInput).trim() !== '') {
          return `${row.taxPercentageInput}%`;
        }
        return 'Khác';
      }
      if (Number(tax) === -2) return 'Không chịu thuế';
      if (Number(tax) === -1) return 'Không kê khai';
      if (tax === '' || tax === null || tax === undefined) return '--';
      return `${tax}%`;
    },
    sanitizeUnitOptions() {
      const arr = this.unitOptions.map(u => String(u || '').trim()).filter(Boolean);
      this.unitOptions = Array.from(new Set(arr));
      if (this.unitOptions.length === 0) {
        this.unitOptions = [...DEFAULT_UNIT_OPTIONS];
      }
    },
    onUnitNameChange(value) {
      if (!value || !String(value).trim()) return;
      const normalized = String(value).trim();
      const exists = this.unitOptions.some(u => String(u || '').trim().toLowerCase() === normalized.toLowerCase());
      if (!exists) {
        this.unitOptions.push(normalized);
      }
    },
    async fetchData() {
      try {
        await this.searchSinvoiceGoodsItems(this.filters);
      } catch {
        NotifyMessage.leftCornerNotificationError('Không tải được danh sách hàng hóa, dịch vụ.');
      }
    },
    handleSearch() {
      this.filters.page = 1;
      this.fetchData();
    },
    handleSizeChange(limit) {
      this.filters.limit = limit;
      this.filters.page = 1;
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.filters.page = page;
      this.fetchData();
    },
    resetForm() {
      this.form = {
        id: null,
        itemCode: '',
        itemName: '',
        quantity: 1,
        unitPrice: 0,
        unitName: '',
        taxPercentage: '',
        taxPercentageInput: null,
        itemNote: ''
      };
    },
    openCreateDialog() {
      this.dialogMode = 'create';
      this.resetForm();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.goodsForm && this.$refs.goodsForm.clearValidate();
      });
    },
    async openEditDialog(row) {
      this.dialogMode = 'edit';
      await this.fillFormById(row.id);
    },
    async openDetailDialog(row) {
      this.dialogMode = 'detail';
      await this.fillFormById(row.id);
    },
    async fillFormById(id) {
      try {
        const response = await this.getSinvoiceGoodsItemDetail(id);
        const data = response && response.data && response.data.data ? response.data.data : null;
        if (!data) {
          NotifyMessage.leftCornerNotificationError('Không tìm thấy thông tin hàng hóa, dịch vụ.');
          return;
        }
        this.form = {
          id: data.id,
          itemCode: data.itemCode || data.productCode || '',
          itemName: data.itemName || '',
          quantity: data.quantity !== undefined && data.quantity !== null && String(data.quantity).trim() !== ''
            ? Number(data.quantity)
            : 1,
          unitPrice: Number(data.unitPrice) || 0,
          unitName: data.unitName || '',
          taxPercentage: data.taxPercentage !== undefined ? data.taxPercentage : '',
          taxPercentageInput: data.taxPercentageInput !== undefined ? data.taxPercentageInput : null,
          itemNote: data.itemNote || ''
        };
        // Đảm bảo đơn vị tính từ dữ liệu có sẵn trong danh sách
        if (data.unitName && String(data.unitName).trim()) {
          this.onUnitNameChange(data.unitName);
        }
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.goodsForm && this.$refs.goodsForm.clearValidate();
        });
      } catch (error) {
        NotifyMessage.leftCornerNotificationError(error && error.message ? error.message : 'Không lấy được chi tiết hàng hóa, dịch vụ.');
      }
    },
    handleTaxChange(value) {
      if (String(value) !== 'other') {
        this.form.taxPercentageInput = null;
      }
      this.$nextTick(() => {
        if (this.$refs.goodsForm) {
          this.$refs.goodsForm.validateField('taxPercentage');
          this.$refs.goodsForm.validateField('taxPercentageInput');
        }
      });
    },
    handleSubmit() {
      if (!this.$refs.goodsForm) return;
      this.$refs.goodsForm.validate(async valid => {
        if (!valid) return;
        this.actionLoading = true;
        try {
          const payload = {
            ...this.form,
            quantity: Number(this.form.quantity) || 1,
            unitPrice: Number(this.form.unitPrice) || 0,
            schoolId: this.getSinvoiceConfigField('idSchool', null)
          };
          if (this.dialogMode === 'create') {
            await this.createSinvoiceGoodsItem(payload);
            NotifyMessage.leftCornerNotificationSuccess('Thêm hàng hóa, dịch vụ thành công.');
          } else {
            await this.updateSinvoiceGoodsItem(this.form.id, payload);
            NotifyMessage.leftCornerNotificationSuccess('Cập nhật hàng hóa, dịch vụ thành công.');
          }
          this.dialogVisible = false;
        } catch (error) {
          NotifyMessage.leftCornerNotificationError(error && error.message ? error.message : 'Không thể lưu dữ liệu.');
        } finally {
          this.actionLoading = false;
        }
      });
    },
    handleDialogClose() {
      this.resetForm();
    },
    async handleDelete(row) {
      try {
        await this.$confirm(
          `Bạn có chắc chắn muốn xóa hàng hóa, dịch vụ "${row.itemName || row.itemCode}" không?`,
          'Xác nhận xóa',
          {
            confirmButtonText: 'Đồng ý',
            cancelButtonText: 'Hủy',
            type: 'warning'
          }
        );
      } catch {
        return;
      }
      try {
        await this.deleteSinvoiceGoodsItem(row.id);
        NotifyMessage.leftCornerNotificationSuccess('Xóa hàng hóa, dịch vụ thành công.');
        if (this.rows.length === 1 && this.filters.page > 1) {
          this.filters.page -= 1;
        }
      } catch (error) {
        NotifyMessage.leftCornerNotificationError(error && error.message ? error.message : 'Xóa hàng hóa, dịch vụ thất bại.');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.goods-service-wrapper {
  padding: 0;
}

.search-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.filter-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pagination-wrapper {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
</style>

